<style lang="less" scoped>
  .btn {
    width: 64px;
    height: 64px;
    background: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: #18a4ff;
  }
</style>

<template lang="pug">
  .btn {{text}}
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '완료',
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/custom_btn.vue